import { render, staticRenderFns } from "./ProjectsGroup.vue?vue&type=template&id=5364d6c1&"
import script from "./ProjectsGroup.vue?vue&type=script&lang=js&"
export * from "./ProjectsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports